import i18n from '@/i18n';
// 通用操作弹窗标题
const operateTitleEnum = {
    phone_edit: i18n.t('message.tips.phoneReplaced'),
    phone_close_verify: i18n.t('message.tips.phoneTurnedOff'),
    email_edit: i18n.t('message.tips.emailReplaced'),
    email_close_verify: i18n.t('message.tips.emailTurnedOff'),
    google_bind: i18n.t('message.tips.authenticatorBound'),
    google_unbind: i18n.t('message.tips.authenticatorUnbound')
};
// 通用操作弹窗类型
const operateTypeEnum = [
    'phone_edit',
    'phone_close_verify',
    'email_edit',
    'email_close_verify',
    'google_bind',
    'google_unbind'
];
// 安全验证弹窗类型
const verifyEnum = [
    'password_verify',
    'phone_close_verify',
    'phone_open_verify',
    'email_close_verify',
    'email_open_verify',
    'google_close_verify'
];
// 验证码业务类型
const codeEnum = {
    password_verify: 4,
    phone_close_verify: 31,
    phone_open_verify: 11,
    email_close_verify: 32,
    email_open_verify: 12,
    google_open_verify: 13,
    google_close_verify: 33
};
// 安全验证操作类型
const verifyOperateEnum = {
    phone_close_verify: 3,
    phone_open_verify: 1,
    email_close_verify: 3,
    email_open_verify: 1,
    google_open_verify: 1,
    google_close_verify: 3
};

// 现货订单类型
const spotOrderType = {
    1: i18n.t('message.spot.limitedPrice'),
    2: i18n.t('message.spot.stopProfitAndLoss'),
    3: i18n.t('message.spot.marketPrice')
};

// 现货买卖类型
const spotBuyType = {
    1: i18n.t('message.spot.buy'),
    2: i18n.t('message.spot.sale')
};

// 现货订单状态类型
const spotStatusType = {
    0: i18n.t('message.spot.uncompleted'),
    1: i18n.t('message.spot.partialTransaction'),
    2: i18n.t('message.spot.completeTransaction'),
    3: i18n.t('message.spot.partialTransactionAdnCancel'),
    4: i18n.t('message.spot.canceled')
};
// 现货订单状态-时间文字
const spotStatusTimeType = {
    0: '',
    1: i18n.t('message.common.updateT'),
    2: i18n.t('message.common.updateT'),
    3: i18n.t('message.common.cancelT'),
    4: i18n.t('message.common.cancelT')
};

// 合约订单-订单类型
const FuturesOrderType = {
    1: i18n.t('message.spot.limitedPrice'),
    2: i18n.t('message.spot.stopProfitAndLoss'),
    3: i18n.t('message.spot.marketPrice'),
    4: i18n.t('message.futures.order.marketPriceProfitOrLoss'),
    5: i18n.t('message.futures.order.closeDelegation'),
    6: i18n.t('message.spot.limitedPriceStopSurplus'),
    7: i18n.t('message.spot.limitedPriceStopLoss'),
    8: i18n.t('message.futures.order.marketPriceStopSurplus'),
    9: i18n.t('message.futures.order.marketPriceStopLoss')
};

// 合约订单-订单类型
const FuturesOrderStatusType = {
    0: i18n.t('message.spot.uncompleted'),
    1: i18n.t('message.spot.partialTransaction'),
    2: i18n.t('message.spot.completeTransaction'),
    4: i18n.t('message.common.cancel'),
    5: i18n.t('message.futures.order.expired')
};

// 订单方向
const OrderDirection = {
    0: i18n.t('message.spot.buy'),
    1: i18n.t('message.spot.sale'),
    2: i18n.t('message.futures.buyMore'),
    3: i18n.t('message.futures.sellEmpty'),
    4: i18n.t('message.futures.flatOut'),
    5: i18n.t('message.futures.pinto')
};

// 提现状态
const WithdrawStatus = {
    1: i18n.t('message.assets.confrimed'),
    2: i18n.t('message.assets.success'),
    3: i18n.t('message.assets.fail')
};

// 现货账户币种流水类型
const TradeType = {
    1: i18n.t('message.header.buyCoin'),
    2: i18n.t('message.assets.sellCoin'),
    5: i18n.t('message.assets.recharge'),
    6: i18n.t('message.assets.withdrawalCoins'),
    101: i18n.t('message.assets.spotTransferContract'),
    102: i18n.t('message.assets.contractTransferSpot'),
    103: i18n.t('message.assets.spotTransferProperty'),
    104: i18n.t('message.assets.propertyTransferSpot')
};
export const formatYYYYMMDD = 'dd-MM-yyyy';
export const formatYYYYMMDD_HHMMSS = 'dd-MM-yyyy HH:mm:ss';
export const customTimezones = 'Europe/Madrid';

export {
    operateTitleEnum,
    verifyEnum,
    operateTypeEnum,
    codeEnum,
    verifyOperateEnum,
    spotOrderType,
    spotBuyType,
    spotStatusType,
    spotStatusTimeType,
    FuturesOrderType,
    FuturesOrderStatusType,
    OrderDirection,
    TradeType,
    WithdrawStatus
};
